import { render, staticRenderFns } from "./Sample_prototype.vue?vue&type=template&id=06f6c016&scoped=true"
import script from "./Sample_prototype.vue?vue&type=script&lang=js"
export * from "./Sample_prototype.vue?vue&type=script&lang=js"
import style0 from "./Sample_prototype.vue?vue&type=style&index=0&id=06f6c016&prod&lang=css"
import style1 from "./Sample_prototype.vue?vue&type=style&index=1&id=06f6c016&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f6c016",
  null
  
)

export default component.exports